import React, { FC } from 'react';

import { IMerchant, INavItem } from 'src/prize/types/shoppe';

import Aragosta from '../../templates/Aragosta';

import styles from './index.module.sass';

interface LastCrumbProps {
  links?: INavItem;
  merchant: IMerchant;
}

const LastCrumb: FC<LastCrumbProps> = ({ links, merchant }) => (
  <Aragosta
    className={{ container: styles.container }}
    links={links}
    logoWidth={360}
    merchant={merchant}
  />
);

export default LastCrumb;
